import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FileList from './files_list';
import FileDetail from './files_detail';

class ReactPressFile extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <FileList/>;
    }else{
      if(params.id===undefined){
        view = <FileDetail/>;
      }else{
        view = <FileDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

ReactPressFile.contextTypes = {
  router: PropTypes.object
};

export default ReactPressFile;
